import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import { ElevatedBox, Card } from 'components/layout'
import { ActivityBadge } from 'components/sections/dashboard'
import getActivityClassName from 'helpers/dashboard/getActivityClassName'
import { ACTIVITY_STATES } from 'constants/enums'
import styles from '../SectionCard/section-card.styl'
import multiStyles from './section-card-multiple.styl'
import BadgeCollection from '../../../../containers/misc/BadgeCollection/BadgeCollection'

const commonStates = [
  ACTIVITY_STATES.award_leader_singoff.id,
  ACTIVITY_STATES.office_signoff.id,
  ACTIVITY_STATES.complete.id,
  ACTIVITY_STATES.replaced.id,
  ACTIVITY_STATES.ceremony.id
]

export default class SectionCardMultiple extends Component {
  static propTypes = {
    showProgress: PropTypes.bool,
    onWarningClick: PropTypes.func,
    onClick: PropTypes.func,
    completedPercentage: PropTypes.number,
    activityProgress: PropTypes.object,
    onGetTitle: PropTypes.func,
    onGetIcon: PropTypes.func,
    activitySection: PropTypes.string,
    activities: PropTypes.array,
    title: PropTypes.object,
    isAJ: PropTypes.bool,
    isBadgesEnabled: PropTypes.bool,
    awardBadges: PropTypes.object,
    awardLevel: PropTypes.object
  }

  static defaultProps = {
    showProgress: false
  }

  getRejectedMessage = (isAJ, activity) => {

    let state

    if(isAJ){
      state = get(activity, 'state.value')
    } else {
      state = get(activity, 'state.value')
    }

    if(state === ACTIVITY_STATES.setup.id){
      return (<FormattedHTMLMessage
        id={`label.${isAJ ? 'aj' : 'activity'}_rejected_click`}
        defaultMessage="Your activity has been rejected by Award Leader.<br /> Click for "
      />)
    } else {
      return (<FormattedHTMLMessage
        id={`label.${isAJ ? 'aj' : 'activity'}_rejected_assessor_click`}
        defaultMessage="Your activity has been rejected by Assessor.<br /> Click for "
      />)
    }
  }

  renderWarning = (icon, activity, rejectedFromCommon = false) => {
    if (get(icon, 'warning')) {
      const { isAJ } = this.props

      return (
        <div
          className={[
            styles.warning,
            multiStyles.warning,
            rejectedFromCommon && multiStyles.warningTop
          ].join(' ')}
        >
          {this.getRejectedMessage(isAJ, activity)}
          <span
            className={styles.warningLink}
            onClick={e => this.props.onWarningClick(e, activity)}
          >
            <FormattedMessage
              id="button.more_information"
              defaultMessage="more information"
            />
          </span>
        </div>
      )
    }
  }

  renderIcon = icon => {
    const { completedPercentage } = this.props
    const iconClass = [styles.sectionIcon].join(' ')

    return (
      <div className={iconClass}>
        {get(icon, 'add') && <i className="ico ico--add" />}
        {get(icon, 'pending') && <i className="ico ico--update" />}
        {get(icon, 'checked') && <i className="ico ico--checked" />}
        {get(icon, 'percent') && (
          <span className={styles.percentage}>
            {completedPercentage}
            <span className={styles.percentageSymbol}> %</span>
          </span>
        )}
      </div>
    )
  }

  render() {
    const {
      activities,
      onClick,
      showProgress,
      activitySection,
      activityProgress,
      isAJ,
      title,
      isBadgesEnabled,
      awardBadges,
      awardLevel
    } = this.props

    const captionClass = [styles.caption, multiStyles.caption].join(' ')
    const hasCommonState = commonStates.includes(
      get(activities[0], 'activityState.value')
    )

    return (
      <div className={styles[getActivityClassName(activitySection)]}>
        <ElevatedBox>
          <Card.Wrap className={multiStyles.wrap}>
            <Card.Left>
              <div className={styles.badge}>
                <ActivityBadge activitySection={activitySection} small />
              </div>
            </Card.Left>

            <Card.Content>

              <Card.Top>

                <Card.Middle>
                  <p className={captionClass}>
                    {title ||
                    get(activities, '[0]activitySection.translationText')}


                  </p>
                </Card.Middle>

                <Card.Right>

                  <div className={styles.sectionIcon}>
                    {isBadgesEnabled && <BadgeCollection awardLevel={awardLevel} awardBadges={awardBadges} activitySection={activitySection} />}

                    {hasCommonState && (
                      <div style={{ float: 'right', marginLeft: '8px' }}>
                        {this.renderIcon(this.props.onGetIcon(activities[0]))}
                      </div>
                    )}
                  </div>
                </Card.Right>
              </Card.Top>


              <Card.Bottom className={styles.progress}>


                {showProgress && activityProgress}
              </Card.Bottom>


              {activities.map((item, index) => {
                const icon = this.props.onGetIcon(item)

                const isFirst = index === 0
                const topClass = [
                  multiStyles.item,
                  isFirst && multiStyles.itemFirst
                ].join(' ')
                const titleClass = [styles.title, multiStyles.title].join(' ')
                // If it was returned on approval
                const isSetup =
                  get(item, isAJ ? 'state.value' : 'activityState.value') ===
                  ACTIVITY_STATES.setup.id
                const showWhenCommonState = !isAJ && !isSetup && isFirst

                /**
                 * Show warning logic:
                 * Activity in setup -> show warning for each item
                 * Activity not in setup -> show warning for the top activity only (common state)
                 * AJ - No common state, show warning for each
                 * RP - There's single item, so show for top activity only
                 */

                return [
                  showWhenCommonState && this.renderWarning(icon, item, true),
                  <Card.Top
                    onClick={() => onClick(item)}
                    className={topClass}
                    key={item.id}
                  >
                    <Card.Middle>
                      <h3 className={titleClass}>
                        {this.props.onGetTitle(item)}
                      </h3>
                    </Card.Middle>

                    {!hasCommonState && (
                      <Card.Right>{this.renderIcon(icon)}</Card.Right>
                    )}
                  </Card.Top>,
                  (isSetup || isAJ) && this.renderWarning(icon, item)
                ]
              })}
            </Card.Content>
          </Card.Wrap>
        </ElevatedBox>
      </div>
    )
  }
}
